import { render, staticRenderFns } from "./EditMenuCatalog.vue?vue&type=template&id=2c7f919e&scoped=true"
import script from "./EditMenuCatalog.vue?vue&type=script&lang=js"
export * from "./EditMenuCatalog.vue?vue&type=script&lang=js"
import style0 from "./EditMenuCatalog.vue?vue&type=style&index=0&id=2c7f919e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7f919e",
  null
  
)

export default component.exports